export const USER_TYPE_ADMIN = 'admin';
export const USER_TYPE_MERCHANT = 'merchant';